import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_manufacturing_order_lineService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { line_id: number }): 
  Promise<{ result: { Id?: number, Amount?: number, PackagingId?: number, Material?: { Id?: number, Description?: string, PackagingLookups?: { MaterialId?: number, PackagingId?: number, Packaging?: { Id?: number, ShortName?: string } }[] } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.line_id)) {
      missingRequiredInParams.push('\'line_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_order_line/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      line_id: number    }) {
        if(isNil(inParams.line_id)) {
          return true; 
        }
      return false;
    }
}
